import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { replace } from "react-router-redux";
import List, {
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "material-ui/List";
import IconButton from "material-ui/IconButton";
import DeleteIcon from "material-ui-icons/Delete";
import EditIcon from "material-ui-icons/Edit";
import PlaylistPlayIcon from "material-ui-icons/PlaylistPlay";
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "material-ui/Dialog";
import AddIcon from "material-ui-icons/Add";

import Loading from "../utils/loading/Loading";
import Retry from "../utils/retry/Retry";
import Empty from "../utils/empty/Empty";

import {
  getPlaylistsRequest,
  getPlaylistsDone,
  getSubcriptionStatusRequest,
} from "./actions";
import { deletePlaylistRequest } from "./delete/actions";

import styles from "./Playlists.scss";

class PlayLists extends React.Component {
  static propTypes = {
    playlists: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      playlists: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string,
          id: PropTypes.string.isRequired,
        })
      ),
    }).isRequired,
    admin: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
      subcription: PropTypes.shape({
        accountStatus: PropTypes.shape({
          isTrialExpired: PropTypes.bool,
          isCardAdded: PropTypes.bool,
          isSubscriptionExpired: PropTypes.bool,
          remaningTrialDays: PropTypes.number,
          stripeCurrentPeriodEnd: PropTypes.string,
        }),
      }),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    getPlaylistsRequest: PropTypes.func.isRequired,
    getPlaylistsDone: PropTypes.func.isRequired,
    getSubcriptionStatusRequest: PropTypes.func.isRequired,
    deletePlaylistRequest: PropTypes.func.isRequired,
    navigateTo: PropTypes.func.isRequired,
  };

  state = {
    deletePlaylistId: "",
    isMobile: false,
    subscription_alert: true,
  };

  componentDidMount() {
    if (document.getElementById("root").getElementsByTagName("section")[0]) {
      document
        .getElementById("root")
        .getElementsByTagName("section")[0].hidden = false;
    }
    if (typeof this.props.playlists.playlists === "undefined") {
      this.getPlaylists();
    }
    this.setState({ isMobile: window.innerWidth < 1200 });
    window.addEventListener(
      "resize",
      () => {
        this.setState({ isMobile: window.innerWidth < 1200 });
      },
      false
    );
    this.getUser();
  }

  componentWillUnmount() {
    this.props.getPlaylistsDone();
  }
  getUser = () => {
    const { id: accessToken, userId } = this.props.login.authData;
    const { user } = this.props.admin;
    this.props.getSubcriptionStatusRequest({ accessToken, userId, user });
  };

  getPlaylists = () => {
    const { id: accessToken, userId } = this.props.login.authData;
    this.props.getPlaylistsRequest({ accessToken, userId });
  };

  handleCreatePlaylist = () => {
    this.props.navigateTo("/playlists/add");
  };

  handleRetry = () => {
    this.getPlaylists();
  };

  handleDeletePlaylist = (deletePlaylistId) => {
    this.setState({ deletePlaylistId });
  };

  handleConfirmDeletePlaylist = () => {
    const { id: accessToken, userId } = this.props.login.authData;

    this.props.deletePlaylistRequest({
      accessToken,
      userId,
      id: this.state.deletePlaylistId,
    });

    this.handleClose();
  };

  handleEditPlaylist = (id, isVideoWall) => {
    let wallVideos = false;
    console.log(id);
    if (isVideoWall) {
      wallVideos = true;
    } else {
      wallVideos = false;
    }
    this.props.navigateTo(`/playlists/update/${id}/${wallVideos}`);
  };

  handleClose = () => {
    this.setState({ deletePlaylistId: "" });
  };

  render() {
    const {
      playlists: { requesting, successful, error, playlists },
    } = this.props;

    const { deletePlaylistId } = this.state;
    const empty = typeof playlists === "undefined" || playlists.length === 0;
    const subscription_alert = this.state.subscription_alert;
    return (
      <div className={styles.centeredContainer}>
        <p
          style={{ textAlign: "center", color: "#2196F3", fontWeight: "bold" }}
        >
          Vos listes de vidéos à diffuser
        </p>
        <Fragment>
          {requesting && <Loading size={80} />}
          {successful && empty && (
            <Empty
              message="Aucune playlist créée."
              icon={<PlaylistPlayIcon />}
            />
          )}
          {successful && !empty && (
            <List className={styles.list}>
              {playlists.map(
                ({ title, description, id, deleting, isVideoWall }) => (
                  console.log("Playlist ", isVideoWall),
                  (
                    <ListItem button key={id} disabled={deleting}>
                      <div className={styles.playlistTitle}>
                        <ListItemText primary={title} secondary={description} />
                      </div>
                      <div className={styles.playlistAction}>
                        <ListItemSecondaryAction>
                          <IconButton
                            aria-label="Éditer"
                            disabled={deleting}
                            onClick={() =>
                              this.handleEditPlaylist(id, isVideoWall)
                            }
                            className={styles.playlistEditIcon}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            aria-label="Supprimer"
                            disabled={deleting}
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleDeletePlaylist(id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </div>
                    </ListItem>
                  )
                )
              )}
            </List>
          )}
          {successful && (
            <Button
              variant={this.state.isMobile ? "fab" : "raised"}
              color="primary"
              aria-label="Ajouter"
              className={this.state.isMobile ? styles.fab : styles.textbutton}
              onClick={this.handleCreatePlaylist}
            >
              {this.state.isMobile ? <AddIcon /> : "Créer ma Playlist"}
            </Button>
          )}
          {error && <Retry message={error} onRetry={this.handleRetry} />}
          <Dialog
            open={deletePlaylistId !== ""}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Supprimer la playlist?
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                La suppression de cette playlist est définitive.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Annuler
              </Button>
              <Button
                onClick={this.handleConfirmDeletePlaylist}
                color="primary"
                autoFocus
              >
                Supprimer
              </Button>
            </DialogActions>
          </Dialog>
        </Fragment>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  playlists: state.playlists,
  login: state.login,
  admin: state.admin,
});

export default connect(mapStateToProps, {
  getPlaylistsRequest,
  getPlaylistsDone,
  deletePlaylistRequest,
  getSubcriptionStatusRequest,
  navigateTo: replace,
})(PlayLists);



// WEBPACK FOOTER //
// ./src/pages/playlists/Playlists.jsx